import * as React from "react";

export const ArrowBack = () => (
  <svg
    className="elm-block elm-pointer-events-none"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 16 24"
    width="16px"
    fill="#404040"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" />
  </svg>
);
